import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "motion/react";
import { Cookie, X } from "lucide-react";
import { Link } from "react-router-dom";

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem("obstuchim_cookies_accepted");
    if (!accepted) {
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("obstuchim_cookies_accepted", "true");
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          id="cookie-consent_banner"
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: "spring", damping: 25, stiffness: 200 }}
          className="fixed bottom-20 lg:bottom-6 left-4 right-4 lg:left-6 lg:right-auto z-[9999] max-w-lg"
        >
          <div className="p-5 rounded-md bg-neutral-900 border border-neutral-800 backdrop-blur-xl shadow-2xl shadow-black/40">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-md bg-primary-500/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                <Cookie className="w-5 h-5 text-primary-400" />
              </div>
              <div className="flex-1">
                <p className="text-lg font-extralight text-neutral-300 mb-3">
                  Мы используем файлы cookie для улучшения работы сайта и персонализации контента.
                  Подробнее в{" "}
                  <Link
                    to="/privacy"
                    className="text-primary-400 hover:text-primary-300 transition-colors underline underline-offset-2"
                  >
                    Политике конфиденциальности
                  </Link>
                  .
                </p>
                <div className="flex items-center gap-3">
                  <button
                    onClick={handleAccept}
                    className="px-5 py-2 rounded-md bg-primary-600 hover:bg-primary-500 text-white text-lg font-medium transition-colors"
                  >
                    Принять
                  </button>
                  <button
                    onClick={handleAccept}
                    className="px-4 py-2 rounded-md border border-neutral-700 text-neutral-400 hover:text-white hover:border-neutral-500 text-lg font-extralight transition-colors"
                  >
                    Закрыть
                  </button>
                </div>
              </div>
              <button
                onClick={handleAccept}
                className="text-neutral-600 hover:text-neutral-300 transition-colors flex-shrink-0"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
